<template>
	<div class="pages">
		<div class="flexbox">
			<img v-if="faceShow==false" src='../../assets/face.png' />
			<img v-else src="../../assets/fail.png" />
		</div>
		<div style="margin-top: 10%;text-align: center;">
			<div class="submittext">{{faceShow==false?'信息采集成功':'信息采集失败'}}</div>
			<!-- 	<view class="riytext">欢迎使用如意刷</view> -->
		</div>
		<button v-if="faceShow==false" class="button" @click="submitHome">下一步</button>
		<button v-else class="button" @click="returnBack">返回</button>
	</div>
</template>
<script type="text/javascript" src="https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js"></script>
<script type="text/javascript">
	import { face, facexcx } from '@/api/index';
	import wx from 'weixin-js-sdk';
	var ua = navigator.userAgent.toLowerCase();
	// import { Toast } from 'vant';
	export default {
		data() {
			return {
				faceShow: false,
				mid: '',
				urlStatus:''
			};
		},
		created() {
			
		
		},
		mounted() {
			var url = window.location.href; //获取地址栏路径
			var temp1 = url.split('?'); //对url地址进行分割
			var pram = temp1[1];
			var keyValue = pram.split('&');
			var obj = {};
			for (var i = 0; i < keyValue.length; i++) {
				//循环分割挂过后的地址
				var item = keyValue[i].split('=');
				var key = item[0];
				var value = item[1];
				obj[key] = value;
			}
			// alert(obj.code);//对data里面定义的orgCode进行赋值
			//    alert(obj.mId);
			if (obj.code != 0) {
				this.faceShow = true
			} else {
				this.faceShow = false
			}
			
			// 小程序接口
			if(ua.match(/MicroMessenger/i)=="micromessenger") {
			        //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
			        wx.miniProgram.getEnv((res)=>{
			           if (res.miniprogram) {
			          facexcx(obj.mId, obj.code).then(res => {
			          	this.mid = res.data
			          });
			           } else {
			              face(obj.mId, obj.code).then(res => {
			              	this.mid = res.data
			              })
			           }
			        })
			    }else{
			     face(obj.mId, obj.code).then(res => {
			     	this.mid = res.data
			     })
			    }

		},
		methods: {
			submitHome() {
				// #ifdef MP-WEIXIN
				wx.miniProgram.navigateTo({
					url: "/pages/authentication/bindThedevice?theDevice=theDevice",
					success: (res) => {
					
					},
					fail: () => {
						
					}
				})
				// #endif
				// this.$uni.navigateTo({
				// 	url: '/pages/authentication/merchantIncomings',
				// 	success: (res) => {
						
				// 	},
				// 	fail: () => {
				//  }
				// })
				this.$uni.navigateTo({
					url: '/pages/authentication/bindThedevice?theDevice=theDevice',
					success: (res) => {
						
					},
					fail: () => {}
				})

				if (this.mid = 'JSB') {
					this.$uni.navigateTo({url: '/pages/authentication/smallmicro/smallmicro?success=1'})
					return
				}


			},
			returnBack() {
				// #ifdef MP-WEIXIN
				wx.miniProgram.navigateTo({
					url: "/pages/authentication/merchantIncomings",
					success: (res) => {
					
					},
					fail: () => {
						
					}
				})
				// #endif
				this.$uni.navigateTo({
					url: '/pages/authentication/merchantIncomings',
					success: (res) => {
						
					},
					fail: () => {}
				})
				
				if (this.mid = 'JSB') {
					this.$uni.navigateTo({
						url: '/pages/authentication/smallmicro/smallmicro/face=1'
					})
					return
				}

			}
		}
	};
</script>
<style lang="scss">
.pages {
	height: 100%;
	width: 100%;
	flex-wrap: nowrap;
	overflow: hidden;
}

.flexbox {
	width: 100%;
	height: 100px;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 10%;

	img {
		width: 80px;
		align-items: center;
		justify-content: center;
		margin-top: 20%;
	}
}

.submittext {
	font-size: 16px;
	font-weight: bold;
}

.riytext {
	font-size: 12px;
	font-weight: 400;
	color: #757880;
	margin-top: 1%;
}

.button {
	width: 95%;
	height: 45px;
	margin-left: 2.5%;
	margin-top: 15%;
	background: linear-gradient(270deg, #d69c63 0%, #f7ce9e 100%);
	border-radius: 28px;
	opacity: 1;
	font-size: 18px;
	line-height: 45px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: 500;
	box-shadow: 1px 5px 12px 1px rgba(247, 206, 158, 0.7);
	border: 0;
}
</style>
